<script>
import appConfig from "@/app.config";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import AddEdit from "./addedit.vue";
import satdosyaihalekomisyonu from "@/models/satdosyaihalekomisyonu";
import gorevlendirmeyazisi from "./gorevlendirmeyazisi.vue";

export default {
  props: ["satdosyaId"],
  mixins: [apibtoast, apigeneric, satdosyaihalekomisyonu],
  page: {
    title: "Teklif Veren Firmalar",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    AddEdit,
    gorevlendirmeyazisi,
  },
  data() {
    return {
      title: this.$t("satdosyaihalekomisyonu.Title"),
      items: [
        {
          text: "",
          href: "/",
        },
        {
          text: "",
          active: true,
        },
        {
          text: this.$t("satdosyaihalekomisyonu.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      Aktarilan: "",
      DataUpdate: "",
      AddEdit: "",
      islem: 0,
      uyesayisikontrol: 0,
      SiradakiNo: 1,
    };
  },
  methods: {
    Get() {
      this.ActionsFilterGet({ Service: "SatDosyaIhaleKomisyonu", Page: this.Page, Filter: "&Dosyaid=" + this.satdosyaId + "&Asc=Sira" }).then((res) => {
        this.TableData = res.Data;

        this.Page.PageDataSize = res.TotalCount;
        this.uyesayisikontrol = this.TableData.length % 2;

        if (res.Data.length > 0) {
          this.SiradakiNo = this.TableData[res.TotalCount - 1].Sira;
        } else {
          this.SiradakiNo = 0;
        }

        this.$emit("aktif_menu_title", this.$t("satdosyaihalekomisyonu.Title"));
      });
    },

    formkontrol() {
      this.satdosyaihalekomisyonuData.Sira = this.SiradakiNo + 1;

      this.satdosyaihalekomisyonuData.Dosyaid = "";
      this.satdosyaihalekomisyonuData.Gorevi = "";
      this.satdosyaihalekomisyonuData.Asilpersonelid = null;
      this.satdosyaihalekomisyonuData.Asilunvan = "";
      this.satdosyaihalekomisyonuData.Yedekpersonelid = null;
      this.satdosyaihalekomisyonuData.Yedekunvan = "";
      this.satdosyaihalekomisyonuData.Deleted = false;

      this.DataUpdate = this.satdosyaihalekomisyonuData;

      this.AddEdit = "Add";
    },
  },
  watch: {
    satdosyaId() {
      this.Get();
    },
  },
};
</script>

<template>
  <div class="row">
    <div class="col-xl-12">
      <div class="card">
        <div class="card-body">
          <div class="row mb-2">
            <div class="col-sm-12">
              <div class="text-sm-end">
                <button v-if="uyesayisikontrol > 0" type="button" class="btn btn-success btn-rounded mb-2 me-2" v-b-modal.gorevlendirmeyazisi @click="(Aktarilan = TableData), (islem = 3)"><i class="mdi mdi-file-export-outline me-1"></i>{{ $t("satdosyaihalekomisyonu.Page.Gorevlendirme") }}</button>

                <button type="button" class="btn btn-primary btn-rounded mb-2 me-2" v-b-modal.satdosyaihalekomisyonu @click="(DataUpdate = satdosyaihalekomisyonuData), formkontrol(), (AddEdit = 'Add'), (islem = 1)"><i class="mdi mdi-plus-box-multiple me-1"></i>{{ $t("satdosyaihalekomisyonu.Page.Ekle") }}</button>
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table mb-0">
              <thead class="table-light">
                <tr>
                  <th>{{ $t("satdosyaihalekomisyonu.Table.Sirano") }}</th>
                  <th>{{ $t("satdosyaihalekomisyonu.Table.Gorevi") }}</th>
                  <th>{{ $t("satdosyaihalekomisyonu.Table.Asilpersonelid") }}</th>
                  <th>{{ $t("satdosyaihalekomisyonu.Table.Asilunvan") }}</th>
                  <th>{{ $t("satdosyaihalekomisyonu.Table.Yedekpersonelid") }}</th>
                  <th>{{ $t("satdosyaihalekomisyonu.Table.Yedekunvan") }}</th>
                  <th style="width: 85px; text-align: center;">{{ $t("satdosyaihalekomisyonu.Table.Islem") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="Data in TableData" :key="Data.Id">
                  <td scope="row">{{ Data.Sira }}</td>
                  <td scope="row">{{ Data.Gorevi }}</td>
                  <td scope="row">{{ Data.Asilpersonel }}</td>
                  <td scope="row">{{ Data.Asilunvan }}</td>
                  <td scope="row">{{ Data.Yedekpersonel }}</td>
                  <td scope="row">{{ Data.Yedekunvan }}</td>

                  <td style="width: 85px; text-align: center;">
                    <b-button-group>
                      <b-button @click="(DataUpdate = Data), (AddEdit = 'Edit'), (islem = 1)" v-b-modal.satdosyaihalekomisyonu v-tooltip="$t('satdosyaihalekomisyonu.Table.Duzelt')" variant="primary">
                        <i class="far fa-pencil-alt"></i>
                      </b-button>
                      <b-button @click="Delete('satdosyaihalekomisyonu', Data.Id)" v-tooltip="$t('satdosyaihalekomisyonu.Table.Sil')" variant="danger">
                        <i class="far fa-trash-alt"></i>
                      </b-button>
                    </b-button-group>
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage" :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table" @input="ChangePage(DefaultPage)"> </b-pagination>
          </div>

          <AddEdit v-show="islem == 1" :Id="DataUpdate" :AddEdit="AddEdit" :satdosyaId="satdosyaId" @TableUpdate="Get" />

          <gorevlendirmeyazisi v-show="islem == 3" :Id="Aktarilan" :satdosyaId="satdosyaId" />
        </div>
      </div>
    </div>
  </div>
</template>
